/* src/app/modules/institutions/institutions-opportunities/institutions-opportunities.component.scss */
:host ::ng-deep .mat-column-title_navigation {
  max-width: 300px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.submodule-opportunities {
  max-height: 350px;
}
/*# sourceMappingURL=institutions-opportunities.component.css.map */
